<template>
	<div v-show="viewId || viewList" class="m-list flex-column">
		<div v-if="emptyView" class="m-list-empty flex-column flex-center">
			<c-empty message="暂无可见视图" height="auto"></c-empty>
			<c-button v-if="viewConfig" color="main" size="dialog" prepend-icon="tf-config" @click="$refs.viewManage.open()">管理视图</c-button>
		</div>

		<template v-else>
			<div v-if="!viewId && viewList" class="m-list-view">
				<c-scroll>
					<div class="flex" style="position: relative;">
						<c-tab-list v-if="viewList.length" ref="viewList" :immediate="false" :tabs="viewList" type="border-tab" @change="viewHandle(arguments[0])">
							<template #default="{data}">
								<div class="flex-center">
									<c-tooltip color="white">
										<div class="view-info flex-center">
											<i class="icon tf" :style="{'color': data.data.icon && data.data.icon != 'default' ? `var(--color-${data.data.icon})` : '#333'}">&#xe63b;</i>
											<p>{{data.name}}</p>
										</div>

										<template #tip>
											<dl class="config-info">
												<dt>数据过滤</dt>
												<dd>
													<template v-if="data.data.filterList.length">
														<div v-for="(item, i) in data.data.filterList" :key="i" class="item flex">
															<label :style="{'width': `${data.data.filterLabelLength}em`}">{{item.label}}</label>
															<div v-if="item.dict" class="flex-grow flex-wrap">
																<template v-for="(tag, j) in item.value">
																	<span v-if="j > 0">、</span>
																	<c-state :key="j" :dict="item.dict" :value="tag"></c-state>
																</template>
															</div>
															<div v-else class="flex-grow ellipsis-2" :title="item.value">{{item.value}}</div>
														</div>
													</template>
													<div v-else class="item">
														<label>未配置过滤条件</label>
													</div>
												</dd>
											</dl>
											<dl v-if="fieldSort" class="config-info">
												<dt>默认排序</dt>
												<dd>
													<template v-if="data.data.sortList.length">
														<div v-for="(item, i) in data.data.sortList" :key="i" class="item flex-center">
															<label :style="{'width': `${data.data.sortLabelLength}em`}">{{item.label}}</label>
															<div class="flex-grow ellipsis-2">{{item.sort}}</div>
														</div>
													</template>
													<div v-else class="item">
														<label>未配置排序条件</label>
													</div>
												</dd>
											</dl>
										</template>
									</c-tooltip>
									<div v-if="viewConfig" class="more" @click.stop>
										<c-dropdown>
											<i class="tf">&#xed7c;</i>

											<template #menu>
												<c-menu-list>
													<c-menu-item icon="tf-edit" @click="viewEditHandle(data.value)">编辑</c-menu-item>
													<c-menu-item icon="tf-copy" @click="viewEditHandle(data.value, true)">复制</c-menu-item>
													<c-menu-item icon="tf-trash" color="red" @click="viewDeleteHandle(data.value)">删除</c-menu-item>
												</c-menu-list>
											</template>
										</c-dropdown>
									</div>
								</div>
							</template>
						</c-tab-list>
						<div v-if="viewList.length && viewConfig" class="m-list-view-config flex-center">
							<i class="tf" @click="$refs.viewManage.open()">&#xe671;</i>
						</div>
					</div>
				</c-scroll>
			</div>

			<div v-if="!viewId && tabList && tabList.length" class="m-list-tab">
				<c-scroll>
					<c-tab-list ref="tabList" :tabs="tabList" type="card" :immediate="false" @change="tabHandle">
						<template #default="{data}">
							<span>{{data.name}}{{data.value !== undefined && tabTotal ? ` (${tabTotal[data.value] || 0})` : ''}}</span>
						</template>
					</c-tab-list>
				</c-scroll>
			</div>

			<slot name="search"></slot>

			<div class="flex-grow flex">
				<div class="flex-grow flex-column">
					<div class="m-list-operate flex">
						<m-operate :batch="batchData.length" @batchCancel="batchCancelHandle">
							<slot name="operate"></slot>
							<c-button ref="dataFilter" prepend-icon="tf-filter" @click="globalDialog('dataFilter', {props: {workType, viewId: currentViewId}, data: {follow: $refs.dataFilter, config: dataFilter}}, (config, save) => afterDataConfig(config, save, 'df'))">数据过滤<ins v-if="dataFilter && dataFilter.length" class="bubble">{{dataFilter.length}}</ins></c-button>
							<c-button v-if="fieldSort" ref="dataSort" prepend-icon="tf-sort" @click="globalDialog('dataSort', {props: {workType, viewId: currentViewId}, data: {follow: $refs.dataSort, config: dataSort}}, (config, save) => afterDataConfig(config, save, 'ds'))">数据排序<ins v-if="dataSort && dataSort.length" class="bubble">{{dataSort.length}}</ins></c-button>

							<template #batch>
								<slot name="batchOperate" :data="batchData"></slot>
								<c-button v-if="batchEdit" prepend-icon="tf-edit" @click="batchFieldEdit(batchData)">编辑</c-button>
							</template>

							<template #right>
								<slot name="otherOperate"></slot>
							</template>
						</m-operate>
						<m-operate v-if="!customView && !dynamicField">
							<template #right>
								<c-button prepend-icon="tf-field-config" @click="globalDialog('fieldConfig', {props: {viewId: currentViewId, params: fieldConfigParams}}, afterFieldConfig)">字段配置</c-button>
							</template>
						</m-operate>
					</div>

					<c-table v-if="!customView" v-show="columnList.length" ref="list" height="grow" width-resize :paging="{size: pageSize}" @widthResize="widthResizeHandle" @pagingChange="pageSizeHandle">
						<c-table-column
							:type="selector ? 'selector' : 'index'"
							width="32"
							:selected="selectedState"
							:summed="summedRow"
							@handle="selectHandle"
						>
							<template #summed>
								<div class="flex-center" style="height: 10px; margin: 0 -5px;">
									<p style="line-height: 14px; font-size: 11px; text-align: center;">本页合计</p>
								</div>
							</template>
						</c-table-column>
						
						<slot></slot>

						<template v-for="(col, i) in columnList">
							<template v-if="col.is_display == 1">
								<c-table-column
									v-if="!col.is_custom"
									:key="col.field_code"
									:label="col.field_title"
									:name="col.field_code"
									:width="col.width"
									:fixed="col.is_lock == 1 ? 'left' : false"
									:summed="summed && col.field_type == 2 && col.is_summed == 1 ? ({data}) => {return parseFloat(data[col.field_code]) || 0} : false"
								>
									<template v-if="$scopedSlots[col.field_code]" #default="{data, update, remove}">
										<slot :name="col.field_code" :data="data" :update="update" :remove="remove"></slot>
									</template>

									<template v-if="$scopedSlots[`${col.field_code}_tip`]" #tip>
										<slot :name="`${col.field_code}_tip`"></slot>
									</template>

									<template v-if="$scopedSlots[`${col.field_code}_summed`]" #summed="{total}">
										<slot :name="`${col.field_code}_summed`" :total="parseFloat(total.toFixed(6))"></slot>
									</template>
									<template v-else-if="$scopedSlots[col.field_code]" #summed="{total}">
										<slot :name="col.field_code" :data="{[col.field_code]: parseFloat(total.toFixed(6))}"></slot>
									</template>
									<template v-else #summed="{total}">
										<span>{{parseFloat(total.toFixed(6))}}</span>
									</template>
								</c-table-column>

								<c-table-column
									v-else
									:key="col.field_code"
									:label="col.field_title"
									:name="col.field_code"
									:width="col.width"
									:fixed="col.is_lock == 1 ? 'left' : false"
									:summed="summed && col.config_json.type == 'number'"
								>
									<template #default="{data}">
										<c-file-list v-if="['file', 'image'].includes(data.customFieldValues[col.field_code].config_json.type)" :value="data.customFieldValues[col.field_code].value" size="mini"></c-file-list>
										<c-tags v-else-if="typeof data.customFieldValues[col.field_code].value == 'object'" :value="data.customFieldValues[col.field_code].value"></c-tags>
										<div v-else-if="data.customFieldValues[col.field_code].config_json.type == 'text' && data.customFieldValues[col.field_code].config_json.attr.includes('textarea')" style="max-height: 75px; overflow: auto; white-space: pre-wrap;">{{data.customFieldValues[col.field_code].value || '-'}}</div>
										<span v-else-if="data.customFieldValues[col.field_code].config_json.type == 'rel_object'">{{data.customFieldValues[col.field_code].display_value || '-'}}</span>
										<span v-else>{{data.customFieldValues[col.field_code].value || '-'}}</span>
									</template>

									<template v-if="col.config_json.tip" #tip>
										<c-tooltip align="end" :tip="col.config_json.tip"></c-tooltip>
									</template>
									
									<template #summed="{total}">
										<span>{{parseFloat(total.toFixed(6))}}</span>
									</template>
								</c-table-column>
							</template>
						</template>

						<template v-for="(col, i) in dynamicColumn">
							<c-table-column
								v-if="col.childFields"
								:key="col.field_title"
								:label="col.field_title"
								:width-resize="false"
							>
								<c-table-column
									v-for="(child, j) in col.childFields"
									:key="child.field_code"
									:label="child.field_title"
									:width="child.width"
									:width-resize="false"
									align-center
									:summed="summed && child.field_type == 2 && child.is_summed == 1 ? ({data}) => {return parseFloat(data.dynamic_field_data[child.field_code]) || 0} : false"
								>
									<template #default="{data}">
										{{data.dynamic_field_data[child.field_code] || '-'}}
									</template>
									
									<template #summed="{total}">
										<span>{{parseFloat(total.toFixed(6))}}</span>
									</template>
								</c-table-column>
							</c-table-column>

							<c-table-column
								v-else
								:key="col.field_title"
								:label="col.field_title"
								:width="col.width"
								:width-resize="false"
								:summed="summed && col.field_type == 2 && col.is_summed == 1 ? ({data}) => {return parseFloat(data.dynamic_field_data[col.field_code]) || 0} : false"
							>
								<template #default="{data}">
									{{data.dynamic_field_data[col.field_code] || '-'}}
								</template>
								
								<template #summed="{total}">
									<span>{{parseFloat(total.toFixed(6))}}</span>
								</template>
							</c-table-column>
						</template>
					</c-table>

					<slot v-else name="customView"></slot>
				</div>

				<dl v-if="selectedFieldConfig" class="m-selected flex-column">
					<dt>已选 {{selectedData.length}} 项</dt>
					<dd class="flex-grow">
						<c-drag-sort v-model="selectedData">
							<template #default="{item, id, index}">
								<c-drag-item :key="id" class="item flex-center">
									<c-drag-handle>
										<i class="c-transfer-option-drag c-icon-sort-drag"></i>
									</c-drag-handle>
									<p class="flex-grow ellipsis">{{item[selectedFieldConfig.name]}}</p>
									<a @click="selectRemoveHandle(item, index)"><i class="tf-cross"></i></a>
								</c-drag-item>
							</template>
						</c-drag-sort>
					</dd>
				</dl>
			</div>
		</template>

		<view-manage v-if="!viewId" ref="viewManage" :work-type="workType" @edit="viewEditHandle" @delete="viewDeleteHandle" @sort="updateView"></view-manage>
		<view-edit v-if="!viewId" ref="viewEdit" :work-type="workType" :dynamic-field="dynamicField" :field-sort="fieldSort" @update="afterViewEdit"></view-edit>
		<work-field-edit v-if="currentViewId" ref="workFieldEdit" :work-type="workType" :view-id="currentViewId" @resolve="update"></work-field-edit>
	</div>
</template>

<script>
	import viewManage from './view_manage.vue'
	import viewEdit from './view_edit.vue'
	import workFieldEdit from './work_field_edit.vue'
	import dictList from '@/store/dict.js'
	import {mapState, mapGetters} from 'vuex'

	export default {
		name: 'viewList',

		components: {
			viewManage,
			viewEdit,
			workFieldEdit
		},

		props: {
			workType: [String, Number],
			viewId: [String, Number],
			viewConfig: Boolean,
			customView: Boolean,
			selector: Boolean,
			batchEdit: Boolean,
			summed: {
				type: Boolean,
				default: true
			},
			selectedField: Object,
			dynamicField: Boolean,
			dynamicFieldParam: {
				type: Function,
				default(data) {
					return {
						dimension_id: data.dimension_id,
						time_granule: data.time_granule,
						start_date: data.start_date,
						end_date: data.end_date
					}
				}
			},
			fieldSort: {
				type:  Boolean,
				default: true
			}
		},

		data() {
			let storage = JSON.parse(localStorage.getItem(this.workType) || '{}');
			return {
				viewList: null,
				currentViewId: storage.v === 0 ? 0 : storage.v || '',
				tabList: null,
				currentTabId: storage.g === 0 ? 0 : storage.g || '',
				tabTotal: null,
				dataFilter: storage.df || null,
				dataSort: storage.ds || null,
				columnList: [],
				dynamicColumn: [],
				selectedData: [],
				batchData: [],
				pageSize: storage.s || 20
			}
		},

		computed: {
			...mapState(['dictData']),
			...mapGetters(['freeEdition']),

			dataUrl() {
				return {
					1: '/order/list',                   //销售订单
					2: '/plan/list',                   	//生产计划
					3: '/work/list',              		//工单列表
					4: '/stockin/order/list',           //入库单
					5: '/stockout/order/list',          //出库单
					6: '/inventory/order/list',         //盘点单
					7: '/product/list',                 //产品列表
					9: '/dic/process/list',             //工序列表
					12: '/supplier/list',              	//供应商列表
					11: '/customer/list',              	//客户列表
					13: '/task/list',              		//任务列表
					14: '/output/list',              	//报工列表
					16: '/stock/record/list',           //库存收发明细
					17: '/stock/list',              	//库存余额
					18: '/stock/detail/list',           //库存余额明细
					19: '/stock/record/summary/list',   //进销存汇总
					25: '/stock/change/record/list',   	//库存变更记录
					27: '/sys_user/list',   	        //系统用户列表
					29: '/out/sourcing/order/list',   	//委外单列表
					32: '/order/deliver/list',   	    //发货单列表
					34: '/assemble/list',   	    	//装配工单列表
					35: '/out/sourcing/progress/list',  //委外动态列表
					36: '/out/sourcing/settle/list',    //委外结算单列表
					39: '/purchase/order/list',         //采购单列表
					40: '/purchase_product/list',        //采购单明细列表
					41: '/order_product/list',          //销售订单明细列表
					33: '/order/deliver/product/list',  //订单发货明细列表
					42: '/quality/output/list',         //报工质检列表
					43: '/test/defects/output/list',    //报工质检处理列表
					45: '/quality/work/list',         	//生产入库检单列表
					47: '/test/defects/work/list',		//生产入库检处理列表
					49: '/stock_batch/list',			//库存批次列表
					51: '/collab/task/list',			//协同任务列表
					61: '/report/data',					//员工绩效
					62: '/report/data',					//工资报表
					63: '/report/data',					//不良品项分布
					64: '/report/data',					//不良品项汇总
					65: '/report/data',					//不良品项明细
					66: '/report/data',					//产量统计
					67: '/report/data',					//生产报表
					68: '/report/data',					//在制品报表
					69: '/report/data',					//用料报表
                    80: '/report/data',					//[报工-质检数据]报表
                    81: '/report/data'					//[生产-质检数据]报表
                }[this.workType]
			},

			emptyView() {
				return !this.viewId && this.viewList && !this.viewList.length;
			},

			params() {
				return {
					view_id: this.currentViewId,
					second_filter_value: this.currentTabId
				}
			},

			selectedFieldConfig() {
				if (this.selectedField) {
					return Object.assign({
						id: 'id',
						name: ''
					}, this.selectedField);
				}
			},

			summedRow() {
				return this.summed && (
					!!this.columnList.find(col => col.is_display == 1 && (col.is_custom ? col.config_json.type == 'number' : (col.field_type == 2 && col.is_summed == 1)))
					||
					!!this.dynamicColumn.find(col => col.childFields ? !!col.childFields.find(child => child.field_type == 2 && child.is_summed == 1) : (col.field_type == 2 && col.is_summed == 1))
				);
			}
		},

		watch: {
			viewList() {
				this.initSearch();
			},

			params(val) {
				this.updateLocalStorage({
					v: val.view_id,
					g: val.second_filter_value
				});
			},

			customView() {
				this.batchData = [];
				this.$nextTick(() => {
					if (this.$search) {
						this.$search.search();
					} else {
						this.loadData();
					}
				});
			}
		},

		mounted() {
			if (this.viewId) {
				this.initSearch();
				this.viewHandle({
					value: this.viewId
				});
			} else {
				this.updateView();
			}
		},

		methods: {
			getViewId() {
				return this.currentViewId;
			},

			initSearch() {
				this.$nextTick(() => {
					this.$search = this.$children.find(item => item.$options.name == 'mSearch');
					if (this.$search) {
						this.$search.viewListHandle = (data, callback) => {
							this._afterSearch = callback;
							this.load(data);
						};
						this.$search.initFold();
					}
				})
			},

			reset() {
				this.selectedData = [];
				this.$refs.list.clear();
				if (!this.columnList.length) return;
				if (this.$search) {
					this.$search.clear();
					this.$search.search();
				} else {
					this.loadData();
				}
			},

			load(data) {
				if (this.dynamicField) {
					this.updateDynamicColumn();
				} else {
					this.loadData(data);
					this.updateTabTotal(data);
				}
			},

			update() {
				this.$refs.list.update();
				this.updateTabTotal();
			},

			refresh() {
				this.$refs.list.refresh();
				this.updateTabTotal();
			},

			updateLocalStorage(data) {
				localStorage.setItem(this.workType, JSON.stringify(Object.assign({
					v: this.currentViewId,
					g: this.currentTabId,
					s: this.pageSize,
					df: this.dataFilter,
					ds: this.dataSort
				}, data)));
			},

			updateView(update = true) {
				update = update && (update === true || this.currentViewId == update);
				this.request({
					url: '/sys_user_view/list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.viewList = data.map(item => {
							item.filterLabelLength = 0;
							item.filterList = Array.from((item.filter_condition || []).filter(item => item.field_config), ({field_config: field, field_value: value, dictDbOptions: options, range_beginTime: startDate, range_endTime: endDate}) => {
								item.filterLabelLength = Math.max(field.field_title.length, item.filterLabelLength);

								if (field.field_type == 1 || (field.field_type == 9 && field.config_json.type == 'text')) {
									return {
										label: field.field_title,
										value
									}
								} else if (field.field_type == 2 || (field.field_type == 9 && field.config_json.type == 'number')) {
									let min = value[1] ? `${value[1].includes('=') ? '大于等于' : '大于'}${value[1].match(/#>[=]?@([\.\d]+)#/)[1]}` : '无限小';
									let max = value[2] ? `${value[2].includes('=') ? '小于等于' : '小于'}${value[2].match(/#<[=]?@([\.\d]+)#/)[1]}` : '无限大';
									return {
										label: field.field_title,
										value: `${min} - ${max}之${value[0] == 'in' ? '内' : '外'}`
									}
								} else if (field.field_type == 3 || (field.field_type == 9 && field.config_json.type == 'time')) {
									let start = value[0].match(/#([a-z_]+)@(-?\d+)#/);
									if (start) {
										value = `${startDate.replace(' 00:00:00', '')} - ${endDate.replace(' 23:59:59', '')}`;
									} else {
										value = `${value[0].replace(' 00:00:00', '')} - ${(value[1] || '未限制').replace(' 23:59:59', '')}`;
									}
									return {
										label: field.field_title,
										value
									}
								} else if (field.field_type == 4 || (field.field_type == 9 && field.config_json.type == 'option')) {
									if (field.config_json.dict_config && field.config_json.dict_config.dictType == 'DBDIC') {
										if (options) {
											options = options.filter(item => value.findIndex(val => val == item.value) != -1);
											if (field.config_json.dict_config.dictName == 'SYSUSER' && value.includes('#curr_login_user_id#')) {
												options.unshift({
													name: '当前登录用户'
												});
											}
											value = options.map(item => item.name);
										}

										return {
											label: field.field_title,
											value: value.join('、')
										}
									} else if (field.config_json.dict_config && field.config_json.dict_config.dictType == 'PAGEDIC') {
										return {
											label: field.field_title,
											dict: field.config_json.dict_config.dictName,
											value
										}
									} else {
										return {
											label: field.field_title,
											value: value.join('、')
										}
									}
								} else if (field.field_type == 9 && field.config_json.type == 'rel_object') {
									return {
										label: field.field_title,
										value: value.map(item => item.name).join('、')
									}
								}
							});
							item.sortLabelLength = 0;
							item.sortList = Array.from((item.sort_config || []).filter(item => item.field_config), ({field_config: field, sort_type: type}) => {
								item.sortLabelLength = Math.max(field.field_title.length, item.sortLabelLength);

								let sort;
								if (field.field_type == 2 || (field.field_type == 9 && field.config_json.type == 'number')) {
									sort = {
										'asc': '0 → 9',
										'desc': '9 → 0'
									}[type]
								} else if (field.field_type == 3 || (field.field_type == 9 && field.config_json.type == 'time')) {
									sort = {
										'asc': '从早到晚',
										'desc': '从晚到早'
									}[type]
								} else if (field.config_json.dict_config && field.config_json.dict_config.dictType == 'PAGEDIC') {
									sort = {
										'asc': '正向排序',
										'desc': '倒向排序'
									}[type]
								} else {
									sort = {
										'asc': 'A → Z',
										'desc': 'Z → A'
									}[type]
								}

								return {
									label: field.field_title,
									sort
								}
							});
							return {
								name: item.view_name,
								value: item.id,
								data: item
							}
						});
						if (this.viewList.length) {
							this.$nextTick(() => {
								let index = this.viewList.findIndex(item => item.value == this.currentViewId);
								if (update || index == -1) this.$refs.viewList.changeIndex(index == -1 ? 0 : index);
								else this.$refs.viewList.currentIndex = index == -1 ? 0 : index;
							})
						}
					}
				});
			},

			updateDynamicColumn() {
				let search = this.$search.get();
				this.$refs.list.clear();
				this.request({
					url: '/sys_user_view/field_list',
					data: Object.assign({
						view_id: this.currentViewId
					}, this.dynamicFieldParam(search)),
					success: data => {
						this.columnList = [];
						this.dynamicColumn = [];
						this.$nextTick(() => {
							this.columnList = data.field_list;
							this.dynamicColumn = data.dynamic_field_list;
							this.loadData(search);
						});
					}
				});
			},

			viewHandle(view) {
				this.$refs.list && this.$refs.list.clear();
				this.request({
					url: '/sys_user_view/config',
					data: {
						view_id: view.value
					},
					success: data => {
						if (!this.dynamicField) {
							this.columnList = [];
							this.$nextTick(() => {
								this.columnList = data.field_list;
							});
						}

						if (data.second_config.fieldId) {
							if (data.second_config.dictOptions) {
								this.tabList = [{name: '全部'}].concat(data.second_config.dictOptions);
							} else if (data.second_config.dictName && dictList[data.second_config.dictName]) {
								this.tabList = [{name: '全部'}].concat(dictList[data.second_config.dictName]);
							} else {
								this.tabList = [];
							}
						} else {
							this.tabList = [];
						}
						this.tabTotal = null;

						this.$nextTick(() => {
							this.currentViewId = view.value;
							if (this.$refs.tabList) {
								let index = this.tabList.findIndex(item => item.value === this.currentTabId);
								this.$refs.tabList.changeIndex(index == -1 ? 0 : index);
							} else {
								this.tabHandle({});
							}
						});
					}
				});
			},

			viewMenuHandle(data, item) {
				if (item.value == 'edit' || item.value == 'copy') {
					this.viewEditHandle(data.value, item.value == 'copy');
				} else if (item.value == 'delete') {
					this.viewDeleteHandle(data.value);
				}
			},

			viewEditHandle(id, copy) {
				this.$refs.viewEdit.open(id, copy);
			},

			afterViewEdit(id) {
				this.updateView(id);
				this.$refs.viewManage.active && this.$refs.viewManage.update();
			},

			afterDataConfig(config, save, key) {
				this[key == 'df' ? 'dataFilter' : 'dataSort'] = config;
				if (this.dynamicField) {
					this.updateDynamicColumn();
				} else {
					this.loadData();
					this.updateTabTotal();
				}
				this.updateLocalStorage({
					[key]: save ? config : null
				});
			},

			afterFieldConfig() {
				if (this.dynamicField) {
					this.updateDynamicColumn();
				} else {
					this.viewHandle({
						value: this.currentViewId
					});
				}
			},

			fieldConfigParams() {
				return this.$search ? this.$search.get() : {};
			},

			viewDeleteHandle(id) {
				this.$confirm({
					title: '确认删除视图？',
					message: '删除后不可恢复，请谨慎操作',
					resolve: () => {
						this.request({
							url: '/sys_user_view/remove',
							data: {
								id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.updateView(false);
								this.$refs.viewManage.active && this.$refs.viewManage.update();
							}
						})
					}
				});
			},

			tabHandle(tab) {
				this.currentTabId = tab.value === 0 ? 0 : tab.value || '';
				if (this.$search) {
					this.$search.search();
				} else {
					this.loadData();
				}
			},

			updateTabTotal(data = this.$search ? this.$search.get() : {}) {
				if (this.tabList.length && this.dataUrl) {
					this.request({
						url: `${this.dataUrl}/groupCount`,
						data: Object.assign({
							view_id: this.currentViewId,
							user_select_filter_condition: this.dataFilter || [],
							user_sort_config: this.dataSort || []
						}, data),
						success: data => {
							if (data) {
								this.tabTotal = {};
								data.forEach(item => {
									this.tabTotal[item.value] = item.count;
								});
							} else {
								this.tabTotal = null;
							}
						},
						fail: () => {
							return false;
						}
					});
				}
			},

			loadData(data = {}) {
				if (!this.dataUrl) return;
				this._searchParams = Object.assign({
					view_id: this.currentViewId
				}, data);
				
				if (this.customView) {
					this.$emit('customView', Object.assign(data, this.params));
				} else {
					this.$refs.list.load({
						url: this.dataUrl,
						data: Object.assign({}, data, this.params, {
							user_select_filter_condition: this.dataFilter || [],
							user_sort_config: this.dataSort || []
						}),
						success: data => {
							this.batchData = [];
							if (this._afterSearch) {
								this._afterSearch(data);
								delete this._afterSearch;
							}
						}
					});
				}
			},

			widthResizeHandle(col) {
				let item = this.columnList.find(item => item.field_code == col.name);
				if (item) {
					item.width = col.width;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: this.viewId || this.currentViewId,
							dimension_id: this.fieldConfigParams().dimension_id || 0,
							field_list: this.columnList.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
			},

			pageSizeHandle(data) {
				this.updateLocalStorage({
					s: data.pageSize
				});
			},

			selectedState(row) {
				return !!this.selectedData.find(item => item[this.selectedFieldConfig.id] == row.data[this.selectedFieldConfig.id]);
			},

			selectHandle(row) {
				if (this.selectedFieldConfig) {
					let index = this.selectedData.findIndex(item => item[this.selectedFieldConfig.id] == row.data[this.selectedFieldConfig.id]);
					if (row.data._selected) {
						if (index == -1) {
							this.selectedData.push(Object.assign({}, row.data));
						}
					} else {
						if (index != -1) {
							this.selectedData.splice(index, 1);
						}
					}
				}

				if (this.$scopedSlots.batchOperate) {
					this.batchData = this.$refs.list.getData('selected');
				}
			},

			batchCancelHandle() {
				this.$refs.list.getRow('selected').forEach(row => {
					row.select(false);
				});
			},

			selectRemoveHandle(data, index) {
				let row = this.$refs.list.getRow(row => row.data[this.selectedFieldConfig.id] == data[this.selectedFieldConfig.id])[0];
				if (row) {
					row.select(false);
				}
				this.selectedData.splice(index, 1);
			},

			batchFieldEdit(data) {
				this.$refs.workFieldEdit.open(data.map(item => item.id));
			},

			/**
			 * 导出所有查询数据
			 * exportType: 3 根据自定义模板导出(存在选中行则根据选中行导出)
			 * */
			exportListByViewId(exportType) {
				let ids = this.$refs.list.getRow('selected').map(item => item.data.id);
				if (exportType == 3) {
					this.exportByTemplate(ids, exportType);
				} else {
					this.request({
						url: '/export/url',
						data: Object.assign({
							export_type: 1,  // 导出数据类型 1=列表  2=-详情
							ids: ids,
							second_filter_value: this.currentTabId   //二级搜索条件
						}, this._searchParams),
						success: data => {
							this.download({
								signFree: true,
								fileName: data.filename,
								url: data.url,
								loading: {
									message: '数据文件生成中...'
								}
							})
						}
					});
				}
			},

			// 批量导出数据
			batchExportByTemplate(){
				var data = this.$refs.list.getRow('selected');
				if (!data.length) {
					this.$message({
						message: '请至少选择一行数据'
					});
					return;
				}
				this.exportByTemplate(data.map(item => item.data.id).join(','));
			},

			// 导出数据
			exportByTemplate(ids, templateType) {
				this.globalDialog('exportTemplateSelector', {
					props: {
						workType: this.workType,
						templateType: templateType || 2
					},
					data: {
						excelParams: Object.assign({
							ids,
							second_filter_value: this.currentTabId   //二级搜索条件
						}, this._searchParams),
						htmlParams: Object.assign({
							ids
						}, this._searchParams)
					}
				});
			},

			//数据报表导出
			exportReportByViewId() {
				this.request({
					url: '/report/data/export/url',
					data: Object.assign({
						second_filter_value: this.currentTabId   //二级搜索条件
					}, this._searchParams),
					success: data => {
						this.download({
							signFree: true,
							fileName: data.filename,
							url: data.url,
							loading: {
								message: '数据文件生成中...'
							}
						})
					}
				});
			},

			/******加载系统业务日志列表**********/
			loadWorkLogDetail() {
				//打开模板选择弹窗
				this.globalDialog('workLogDetail', {
					props: {
						workType: this.workType
					}
				});
			},

			/******导入Excel数据**********/
			excelImport(paramData) {
				this.globalDialog('excelImport', {
					props: {
						workType: this.workType
					},
					data: paramData || {}
				}, () => {
					setTimeout(() => {
						this.update();
					}, 300);
				});
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail() {
				//打开模板选择弹窗
				this.globalDialog('importLogDetail', {
					props: {
						workType: this.workType
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.view-info {
		height: 26px;
	}

	.config-info {
		width: 300px;
		padding: 6px 5px;
		color: #000;

		&:nth-child(n+2) {
			padding-top: 0;
		}

		dt {
			line-height: 30px;
			font-size: 14px;
			font-weight: bold;
		}

		.item {
			padding: 3px 0;
			line-height: 18px;
			font-size: 13px;
			word-break: break-word;

			label {
				margin-right: 10px;
				text-align: right;
				color: #666;
			}
		}
	}

	.m-list {
		height: 100%;

		&-operate {
			>>> .m-operate {
				&[empty] + .m-operate,
				&:nth-child(1) {
					flex-grow: 1;
					width: 0;
				}

				&:nth-child(2) {
					padding-left: 8px;
				}

				&:nth-last-child(2) {
					padding-right: 0;
				}
			}

			.bubble {
				position: absolute;
				right: -5px;
				top: -5px;
				box-sizing: border-box;
				min-width: 16px;
				padding: 0 3px;
				border-radius: 8px;
				line-height: 16px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				background: #FFA82B;
			}
		}

		&-empty {
			height: 100%;
		}

		&-view {
			box-sizing: border-box;
			height: 52px;
			border-bottom: 1px solid var(--unit-line);

			>>> .c-scroll {
				height: 52px !important;
			}

			&-config {
				position: sticky;
				right: 0;
				padding: 10px 10px 0;
				margin-bottom: 1px;
				margin-left: 1px;
				background: #fff;

				.tf {
					border-radius: 4px;
					padding: 6px;
					color: #333;
					cursor: pointer;

					&:hover {
						color: var(--color-main);
						background: #F2F2F2;
					}
				}
			}

			>>> ul {
				padding-right: 0;
			}

			>>> li {
				padding: 0 15px;
				white-space: nowrap;
			}

			.icon {
				margin-right: 6px;
				font-size: 16px;
				font-weight: normal;
			}

			.more {
				border-radius: 4px;
				padding: 0 2px;
				margin-left: 6px;
				font-weight: normal;
				color: #999;

				.tf {
					padding: 5px 0;
				}

				&:hover {
					background: #F2F2F2;
				}
			}
		}

		&-tab {
			height: 54px;

			>>> .c-tab-list {
				ul {
					gap: 10px;
					float: left;

					li {
						border: none;
						border-radius: 17px;
						margin: 0;
						white-space: nowrap;

						&:not(.z-crt) {
							background: #F5F5F5;
						}
					}
				}
			}

			+ .m-search {
				padding-top: 0;
			}
		}
	}

	.m-selected {
		width: 250px;
		border: 1px solid var(--table-border);
		border-width: 1px 0 0 1px;

		dt {
			border-bottom: 1px solid var(--table-border);
			padding: 0 12px;
			line-height: 42px;
			background: #FAFAFA;
		}

		dd {
			overflow: auto;

			.item {
				gap: 8px;
				height: 36px;
				padding: 0 12px;

				&:hover {
					background: #eee;
				}

				p {
					line-height: 30px;
					font-size: 13px;
				}

				a {
					padding: 4px;
					color: #999;

					&:hover {
						color: #f00;
					}
				}
			}
		}
	}
</style>